import { SVGProps, Ref, forwardRef } from 'react';

export const LinkedinBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2.02v11.96A1.02 1.02 0 0 1 13.98 15H2.02A1.02 1.02 0 0 1 1 13.98V2.02A1.02 1.02 0 0 1 2.02 1h11.96A1.02 1.02 0 0 1 15 2.02m-4.565 4.084c1.173 0 2.523.793 2.523 2.835v4.02h-2.041V9.431c0-1.08-.598-1.528-1.182-1.528-.711 0-1.443.478-1.443 1.554v3.5H6.25V6.25h1.925v.948h.026c.193-.411 1.062-1.094 2.234-1.094m-5.352.146H3.042v6.708h2.041zm-.018-2.854c.129.198.196.43.193.667v.043a1.167 1.167 0 0 1-1.195 1.138h-.015a1.196 1.196 0 1 1 1.017-1.848"
                fill="#2867B2"
            />
            <path d="M5.083 6.25H3.042v6.708h2.041z" fill="white" />
            <path
                d="M12.958 8.94c0-2.042-1.35-2.836-2.523-2.836-1.172 0-2.041.683-2.234 1.094h-.026V6.25H6.25v6.708h2.042v-3.5c0-1.076.732-1.554 1.443-1.554.584 0 1.182.449 1.182 1.528v3.526h2.041z"
                fill="white"
            />
            <path d="M5.258 4.063a1.196 1.196 0 1 0-1.21 1.18h.014a1.166 1.166 0 0 0 1.196-1.137z" fill="white" />
        </g>
    </svg>
));
LinkedinBrandSize16Glyph.displayName = 'LinkedinBrandSize16Glyph';
